import { Setup } from './Setup';
import { SpidersGameBoard } from "./Board";

export function BoardContainer ({ ctx, G, moves }) {
  return (
    ctx.phase === 'setup' ? <Setup moves={moves}/> : <SpidersGameBoard ctx={ctx} G={G} moves={moves}/>
  )
}